import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './CountryList.module.scss';
import Flag from '../Flag/Flag';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import Checkbox from '../Checkbox/Checkbox';
import Dropdown from '../Dropdown/Dropdown'; // Import Dropdown

const CountryList = ({
    countries = [],
    activeCountryCode,
    onCountryClick,
    isCheckbox = false,
    isOpen,
    onToggle,
    isFlowmap = false,
    disableMobileStyle = false,
}) => {
    const [search, setSearch] = useState('');

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const filteredCountries = countries.filter((country) =>
        country.name.toLowerCase().includes(search.toLowerCase())
    );

    const classes = classNames(s.Root, {
        [s['Flowmap']]: isFlowmap,
        [s['DisableMobile']]: disableMobileStyle,
    });

    const countryListContent = (
        <div className={classes}>
            {!isFlowmap && (
                <div className={s.Search}>
                    <Icon name="Search" className={s.SearchIcon} />
                    <input
                        type="text"
                        placeholder="Search by country"
                        value={search}
                        onChange={handleSearchChange}
                        className={s.SearchInput}
                    />
                </div>
            )}

            <ul className={s.List}>
                {filteredCountries.length > 0 ? (
                    filteredCountries.map((country, index) => {
                        const isActive = country.code === activeCountryCode;
                        const classes = classNames(s.Item, {
                            [s['Item--Active']]: isActive,
                        });
                        return (
                            <li key={index} className={classes}>
                                <button
                                    className={s.Button}
                                    onClick={() => onCountryClick(country)}>
                                    <Flag countryCode={country.code} />
                                    <span className={s.CountryName}>
                                        {country.name}
                                    </span>
                                    {isActive && !isCheckbox && (
                                        <Icon
                                            name="ArrowRight"
                                            className={s.ArrowIcon}
                                        />
                                    )}
                                    {isCheckbox && (
                                        <Checkbox
                                            checked={isActive}
                                            onChange={() =>
                                                onCountryClick(country)
                                            }
                                        />
                                    )}
                                </button>
                            </li>
                        );
                    })
                ) : (
                    <li className={s.NoMatch}>No matches found</li>
                )}
            </ul>
            <span className={s.Fade} />
        </div>
    );

    return (
        <>
            {!disableMobileStyle && (
                <div className={s.Mobile}>
                    <Dropdown
                        isOpen={isOpen}
                        onToggle={onToggle}
                        title={
                            activeCountryCode
                                ? countries.find(
                                      (country) =>
                                          country.code === activeCountryCode
                                  ).name
                                : 'Select a country'
                        }
                        modifiers={['RoundedBorders', 'Grey', 'Toolbox']}>
                        {countryListContent}
                    </Dropdown>
                </div>
            )}

            <div
                className={classNames(s.Desktop, {
                    [s.DisableMobile]: disableMobileStyle,
                })}>
                {countryListContent}
            </div>
        </>
    );
};

CountryList.propTypes = {
    countries: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    activeCountryCode: PropTypes.string,
    onCountryClick: PropTypes.func.isRequired,
    isCheckbox: PropTypes.bool,
};

export default CountryList;
